/* Express Matting – conversion fixes, 21-10-2026. Loaded after em-header-commerce.js (and emx-pdp.js on product pages).
   1. Header calculator: the Add to basket button says what it will add ("Add 20 to basket · £999.80").
      The calculator opens with a 4.2 × 3.6 m room and the 1 m MegaFloor tile, so one tap used to add 20 tiles
      under a plain "Add to basket" label.
   2. Product pages below 1024px: show the sticky price + Add to basket bar while the main buy buttons are still
      below the screen, not only after scrolling past them. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);

  // 1. Calculator button label. em-header-commerce.js recalculates on "input" on each field and on "emh:vat";
  //    this runs after it (listener on the form / added later) and reads its results.
  document.querySelectorAll("[data-emh-calc]").forEach(form => {
    const out = k => $(`[data-o="${k}"]`, form);
    const btn = out("add");
    if (!btn) return;
    const label = () => {
      if (btn.disabled) return; // "Adding…" / "Added" in progress
      const qty = (out("qty")?.textContent || "").trim();
      const cost = (out("cost")?.textContent || "").trim();
      btn.textContent = /\d/.test(qty) && /\d/.test(cost) ? `Add ${qty} to basket · ${cost}` : "Add to basket";
    };
    form.addEventListener("input", label);
    form.addEventListener("change", label);
    document.addEventListener("emh:vat", () => setTimeout(label));
    label();
  });

  // 2. Sticky buy bar on phones and tablets. emx-pdp.js is included further down the page, so wait for it.
  if (!$("emx-pdp") || !window.customElements) return;
  customElements.whenDefined("emx-pdp").then(() => {
    const pdp = $("emx-pdp");
    const actions = pdp && $("[data-emx-actions]", pdp);
    if (!actions || typeof pdp.updSticky !== "function") return;
    const narrow = matchMedia("(max-width: 1023px)");
    const upd = pdp.updSticky;
    pdp.updSticky = function () {
      const s = this.stk;
      if (s) {
        const r = actions.getBoundingClientRect();
        s.past = r.bottom < 0 || (narrow.matches && r.top > innerHeight);
      }
      return upd.call(this);
    };
    pdp.updSticky();
  });
})();
